import React from 'react';
import { Table, Header, Segment, Checkbox, Button, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const MAX_ECTS_IN_SEMESTER = 30;

// TODO: extract to api file
const currentCoursesRequest = (sspid) => axios.get('/students/courses/current-semester');
const availableCoursesRequest = (sspid) => axios.get('/students/courses/next-year');


export default class CollisionCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentCourses: [],
            availableCourses: [],
            checkedCourses: [],
            maxRemainingECTS: MAX_ECTS_IN_SEMESTER,
            sspid: '',
            loading: true,
            error: false,

        };
        this.fetchCurrentAndAvailableCourses = this.fetchCurrentAndAvailableCourses.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.calculateMaxRemainingECTS = this.calculateMaxRemainingECTS.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    componentDidMount() {
        this.fetchCurrentAndAvailableCourses();
    }
    onSubmit() {
        const { sspid, checkedCourses } = this.state;
        if (!checkedCourses.length) return;
        const ids = checkedCourses.map(el => el.courseImplementationId);
        axios.post('/students/courses/select-additional', [...ids])
            .then(res => {
                this.fetchCurrentAndAvailableCourses(sspid);
                toast(<FormattedMessage id="common.successfully" />);
            }).catch(err => toast(<FormattedMessage id="common.error" />));
    }
    handleCheckboxChange(courseImplementationId, checked) {
        const { availableCourses, checkedCourses } = this.state;
        const targetCourse = availableCourses.find(el => el.courseImplementationId === courseImplementationId);
        if (checked) {
            // check if remaining ects after is >0
            // TODO: extract ects reducer to utils
            if (checkedCourses.reduce((a, c) => a + c.ects, 0) + targetCourse.ects > this.state.maxRemainingECTS) return;
            // add
            this.setState({
                checkedCourses: [...checkedCourses, targetCourse]
            });
        } else {
            const filtered = checkedCourses.filter(el => el.courseImplementationId !== courseImplementationId);
            this.setState({
                checkedCourses: filtered
            });
        }
    }
    calculateMaxRemainingECTS() {
        const maxRemainingECTS = MAX_ECTS_IN_SEMESTER - this.state.currentCourses.reduce((a, v) => a + v.ects, 0);
        this.setState({ maxRemainingECTS });
    }
    fetchCurrentAndAvailableCourses(sspid) {
        axios.all([currentCoursesRequest(sspid), availableCoursesRequest(sspid)])
            .then(axios.spread((currentRes, availableRes) => {
                this.setState({
                    currentCourses: currentRes.data,
                    availableCourses: availableRes.data,
                    checkedCourses: [],
                    maxRemainingECTS: MAX_ECTS_IN_SEMESTER,
                    sspid,
                    loading: false
                }, () => this.calculateMaxRemainingECTS());
            }))
            .catch(err => {
                toast(<FormattedMessage id="common.error" />);
                this.setState({ error: true });
            });
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const { currentCourses, availableCourses, checkedCourses } = this.state;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="student.collision" />}</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            {<FormattedMessage id="student.availableCollision" />}

                            <Header as="h3" floated="right" >
                                {<FormattedMessage id="student.theRestEcts" />} {this.state.maxRemainingECTS - checkedCourses.reduce((a, c) => a + c.ects, 0)}
                            </Header>
                        </Header>
                    </Segment>
                    <Segment >
                        {availableCourses.length > 0 ?
                            <AvailableCoursesTable
                                data={this.state.availableCourses}
                                checkedCourses={checkedCourses}
                                handleCheckboxChange={this.handleCheckboxChange}
                                maxRemainingECTS={this.state.maxRemainingECTS}
                                onSubmit={this.onSubmit}
                            /> : <NoAvailableCoursesMessage />}
                    </Segment>
                </Segment.Group>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">{<FormattedMessage id="student.currentCourses" />}</Header>
                    </Segment>
                    <Segment >
                        {currentCourses.length ?
                            <CurrentCoursesTable data={currentCourses} />
                            : <NoCurrentCoursesMessage />
                        }
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

const NoAvailableCoursesMessage = () => <span>{<FormattedMessage id="student.noCollisionMessage" />}</span>;
const NoCurrentCoursesMessage = () => <span>{<FormattedMessage id="student.noCoursesMessage" />}</span>;

const AvailableCoursesTable = ({
    data, checkedCourses, handleCheckboxChange, maxRemainingECTS, onSubmit
}) => (
    <Table celled selectable compact unstackable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>{<FormattedMessage id="common.course" />}</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.teacher" />}</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.lecture" />}</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.exercise" />}</Table.HeaderCell>
                <Table.HeaderCell>ECTS</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.select" />}</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {data.map(row => (
                <Table.Row key={row.courseImplementationId}>
                    <Table.Cell verticalAlign="middle">{row.courseName}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.teacherName}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.lectureHours}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.exerciseHours}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.ects}</Table.Cell>
                    <Table.Cell verticalAlign="middle">
                        <Checkbox
                            checked={checkedCourses.find(el => el.courseImplementationId === row.courseImplementationId)}
                            onChange={(e, { checked }) => handleCheckboxChange(row.courseImplementationId, checked)}
                        />
                    </Table.Cell>
                </Table.Row>
            ))}
        </Table.Body>
        <Table.Footer>
            <Table.Row>
                <Table.HeaderCell colSpan={6}>
                    <Header as="div" floated="right">
                        {<FormattedMessage id="student.theRestEcts" />} {maxRemainingECTS - checkedCourses.reduce((a, c) => a + c.ects, 0)}
                        {'  '}
                        <Button disabled={!checkedCourses.length} onClick={onSubmit}>{<FormattedMessage id="common.send" />}</Button>
                    </Header>
                </Table.HeaderCell>
            </Table.Row>
        </Table.Footer>
    </Table>
);

const CurrentCoursesTable = ({ data }) => (
    <Table celled selectable compact unstackable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>{<FormattedMessage id="common.course" />}</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.teacher" />}</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.lecture" />}</Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.exercise" />}</Table.HeaderCell>
                <Table.HeaderCell>ECTS</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {data.map(row => (
                <Table.Row key={row.courseImplementationId}>
                    <Table.Cell verticalAlign="middle">{row.courseName}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.teacherName}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.lectureHours}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.exerciseHours}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.ects}</Table.Cell>
                </Table.Row>
            ))}
        </Table.Body>
    </Table>
);



// WEBPACK FOOTER //
// ./src/views/StudentOptionalCourses/CollisionCourses.js